import { apiClient } from '@api';
import { IntakeForm } from '@qmd-types/intakeForms';

type AnswerPharmacyIntakeFormQuestionParams = {
  intakeFormId: string;
  intakeFormQuestionId: string;
  data: {
    pharmacyId: string;
  };
};
type AnswerBodyMeasurementIntakeFormQuestionParams = {
  intakeFormId: string;
  intakeFormQuestionId: string;
  data: {
    heightInches: number | null;
    weightPounds: number | null;
  };
};

export async function answerBodyMeasurementIntakeFormQuestion({
  intakeFormId,
  intakeFormQuestionId,
  data,
}: AnswerBodyMeasurementIntakeFormQuestionParams): Promise<void> {
  const url = `/api/v1/intakeforms/${intakeFormId}/questions/${intakeFormQuestionId}/bodymeasurement`;

  await apiClient.post(url, data);
}

type AnswerConditionIntakeFormQuestionParams = {
  intakeFormId: string;
  intakeFormQuestionId: string;
  data: {
    option?: string;
    inputValue: string | null;
  };
};

export async function answerConditionIntakeFormQuestion({
  intakeFormId,
  intakeFormQuestionId,
  data,
}: AnswerConditionIntakeFormQuestionParams): Promise<void> {
  const url = `/api/v1/intakeforms/${intakeFormId}/questions/${intakeFormQuestionId}/condition`;

  await apiClient.post(url, data);
}

type AnswerEmailIntakeFormQuestionParams = {
  intakeFormId: string;
  intakeFormQuestionId: string;
  data: {
    email: string;
  };
};

export async function answerEmailIntakeFormQuestion({
  intakeFormId,
  intakeFormQuestionId,
  data,
}: AnswerEmailIntakeFormQuestionParams): Promise<void> {
  const url = `/api/v1/intakeforms/${intakeFormId}/questions/${intakeFormQuestionId}/email`;

  await apiClient.post(url, data);
}

export async function answerPharmacyIntakeFormQuestion({
  intakeFormId,
  intakeFormQuestionId,
  data,
}: AnswerPharmacyIntakeFormQuestionParams): Promise<void> {
  const url = `/api/v1/intakeforms/${intakeFormId}/questions/${intakeFormQuestionId}/pharmacyselection`;

  await apiClient.post(url, data);
}

type AnswerOptionIntakeFormQuestionParams = {
  intakeFormId: string;
  intakeFormQuestionId: string;
  data: {
    options: string[];
  };
};

export async function answerOptionIntakeFormQuestion({
  intakeFormId,
  intakeFormQuestionId,
  data,
}: AnswerOptionIntakeFormQuestionParams): Promise<void> {
  const url = `/api/v1/intakeforms/${intakeFormId}/questions/${intakeFormQuestionId}/option`;

  await apiClient.post(url, data);
}

type AnswerTextboxIntakeFormQuestionParams = {
  intakeFormId: string;
  intakeFormQuestionId: string;
  data: {
    text: string;
  };
};

export async function answerTextboxIntakeFormQuestion({
  intakeFormId,
  intakeFormQuestionId,
  data,
}: AnswerTextboxIntakeFormQuestionParams): Promise<void> {
  const url = `/api/v1/intakeforms/${intakeFormId}/questions/${intakeFormQuestionId}/textbox`;

  await apiClient.post(url, data);
}

export async function completeIntakeForm(intakeFormId: string): Promise<void> {
  const url = `/api/v1/intakeforms/${intakeFormId}/complete`;

  await apiClient.put(url, {});
}

export async function fetchIntakeForm(id: string): Promise<IntakeForm> {
  const { data } = await apiClient.get<IntakeForm>(`/api/v1/intakeforms/${id}`);

  return data;
}
